import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import classNames from 'classnames';
import TextButton from '../../../../../elements-buttons/text-button';
import AddOnField from '../../fields/AddOnField/AddOnField';
import TextField from '../../fields/TextField/TextField';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

const translationMessages = defineMessages({
  taxFieldPlaceholder: {
    id: 'hosting.add_taxes.tax_field_placeholder',
    defaultMessage: 'Tax name, i.e. Sales tax'
  },
  taxFieldErrorMessage: {
    id: 'hosting.add_taxes.tax_field_error_message',
    defaultMessage: 'Please enter a title'
  }
});
export default class AddTaxes extends Component {
  constructor (props) {
    super(props);
    this.handleAddClick = this.handleAddClick.bind(this);
  }

  componentDidMount () {
    if (!this.props.addAddtlTaxes && 0 >= this.props.fields.length) {
      this.handleAddClick();
    }
  }

  handleAddClick (e) {
    if (e) { e.preventDefault(); }

    this.props.fields.push({
      charge_type: 'tax',
      charge_unit: '%'
    });
  }

  render () {
    const { classnames, fields, addAddtlTaxes, intl, taxError } = this.props;
    return (
      <div className={classNames('add-taxes-component', classnames)}>
        {
          fields.map((tax, index) => {
            return (
              <div className="tax-block" key={tax}>
                <Field
                  name={`${tax}.label`}
                  component={TextField}
                  className="margin-md-bottom"
                  placeholder={intl.formatMessage(translationMessages.taxFieldPlaceholder)}
                  errorMessage={taxError ? null : intl.formatMessage(translationMessages.taxFieldErrorMessage)}
                  attributes={{ 'data-testing-id': 'tax-label-field' }}
                  isError={!!taxError}
                />
                <div>
                  <div className="flex space-between">
                    <Field
                      name={`${tax}.amount`}
                      fieldType="number"
                      component={AddOnField}
                      label="%"
                      className="tax-field"
                      attributes={{ 'data-testing-id': 'tax-amount-field' }}
                      isError={!!taxError}
                    />
                    <div className="flex-col-2" />
                  </div>
                  {taxError && <div className="help-block text-danger">
                    {taxError}
                  </div>}
                </div>
                { addAddtlTaxes &&
                  <div className="flex space-between margin-md-top">
                    <div>
                      {
                        (index === fields.length - 1) &&
                        <TextButton
                          onClick={this.handleAddClick}
                          buttonText={<FormattedMessage id="hosting.add_taxes.button_text_add_more" defaultMessage="Add more"/>}
                          attributes={{ 'data-testing-id': 'add-more-taxes-button' }}
                          classNames="underline no-padding"
                        />
                      }
                    </div>
                    <TextButton
                      onClick={(e) => { e.preventDefault(); fields.remove(index); }}
                      buttonText={<FormattedMessage id="hosting.add_taxes.button_text_remove" defaultMessage="Remove"/>}
                      icon="x"
                      attributes={{ 'data-testing-id': 'remove-tax-button' }}
                      classNames="underline no-padding"
                    />
                  </div> }
              </div>
            );
          })
        }

        {
          0 >= fields.length && addAddtlTaxes &&
          <div>
            <TextButton
              onClick={this.handleAddClick}
              buttonText={<FormattedMessage id="hosting.add_taxes.button_text_add_tax" defaultMessage="+ Add tax"/>}
              attributes={{ 'data-testing-id': 'add-tax-button' }}
              classNames="underline no-padding"
            />
          </div>
        }
      </div>
    );
  }
}

export const AddTaxesIntl = injectIntl(AddTaxes);

AddTaxes.propTypes = {
  classnames: PropTypes.string,
  fields: PropTypes.object,
  addAddtlTaxes: PropTypes.bool
};
